import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAccountReducer from '../reducers/account.reducer';

export const selectState = createFeatureSelector<fromAccountReducer.State>(
  fromAccountReducer.featureKey
);

export const getUser = createSelector(selectState, (state) => state.userProfle);
export const getScorers = createSelector(selectState, (state) => state.scorers);
export const getPlayers = createSelector(selectState, (state) => state.players);